export const DAYS = 3;

export const localizeKey = {
  1: 'OrderExtensionOneDay',
  2: 'OrderExtensionTwoDays',
  3: 'OrderExtensionThreeDays',
};
